  document.addEventListener('DOMContentLoaded', () => {
  const mobileHeader = document.querySelector('.header__block--mobile');
  const toggleButton = mobileHeader?.querySelector('.disclosure__toggle');
  const disclosureList = mobileHeader?.querySelector('.disclosure-list');

  if (toggleButton && disclosureList) {
    toggleButton.addEventListener('click', () => {
      disclosureList.classList.toggle('disclosure-list--visible');
    });
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const mobileHeader = document.querySelector('.header__block--mobile'); 
  const form = mobileHeader?.querySelector('#localization_form-footer');
  const options = form?.querySelectorAll('.disclosure-list__option');
  const inputField = form?.querySelector('input[name="currency_code"]');
  if (form && options && inputField) {
    options.forEach(option => {
      option.addEventListener('click', (event) => {
        event.preventDefault(); 
        const selectedValue = option.getAttribute('data-value');
        inputField.value = selectedValue;
        form.submit();
      });
    });
  }
});

  if (window.innerWidth > 991) {
document.querySelectorAll('.mega_menu_sub_link').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        const parentLi = this.closest('li');
        if (parentLi) {
            const siblingAnchors = parentLi.parentElement.querySelectorAll('li .mega_menu_sub_link');
            siblingAnchors.forEach(anchor => {
                anchor.classList.remove('mega_menu_sub_link_active');
            });

            this.classList.add('mega_menu_sub_link_active');
        }
        const targetSelector = this.getAttribute('data-target');
        if (targetSelector) {
            const targetDiv = document.querySelector('.'+targetSelector);
            if (targetDiv) {
                const siblingDivs = [...targetDiv.parentElement.children];
                siblingDivs.forEach(div => {
                    div.classList.remove('show_grand_child_link');
                });
                targetDiv.classList.toggle('show_grand_child_link');
            }
        }
    });
});
 } else {
    document.querySelectorAll('.mega_menu_sub_link').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            // Get the target selector and adjust it for mobile
            let targetSelector = this.getAttribute('data-target');
            targetSelector = targetSelector + '_mob';
            console.log('target: ' + targetSelector);

            if (targetSelector) {
                const targetDiv = document.querySelector('.' + targetSelector);
                if (targetDiv) {
                    targetDiv.classList.toggle('show_grand_child_link');
                }
            }
        });
    });
}



 const menu = document.querySelector(".menu");
 const menuMain = menu.querySelector(".menu-main");
 const goBack = menu.querySelector(".go-back");
 const menuTrigger = document.querySelector(".mobile-menu-trigger");
 let subMenu;
 menuMain.addEventListener("pointerover", (e) => {
   const hoveredItem = e.target.closest('.menu-main-li');
   const focusedElement = document.activeElement;
   const focusedItem = focusedElement?.closest('.menu-main-li');
   if (window.innerWidth > 991 && hoveredItem && focusedItem && hoveredItem !== focusedItem) {
     focusedElement.blur();
   }
 });
 menuMain.addEventListener("click", (e) =>{
   if (e.target.closest('[data-menu-trigger]')) {
     e.preventDefault();
   }
 	if(!menu.classList.contains("active")){
 		return;
 	}
   if(e.target.closest(".menu-item-has-children")){
   	 const hasChildren = e.target.closest(".menu-item-has-children");
      showSubMenu(hasChildren);
   }
 });
 goBack.addEventListener("click",() =>{
 	 hideSubMenu();
 })
 menuTrigger.addEventListener("click",() =>{
 	 toggleMenu();
 })

 document.querySelector(".menu-overlay").addEventListener("click",() =>{
 	toggleMenu();
 })
  document.querySelector("#close_menu").addEventListener("click", toggleMenu);

 function toggleMenu(){
 	menu.classList.toggle("active");
   document.querySelector("body").classList.toggle("lock_scroll");
 	document.querySelector(".menu-overlay").classList.toggle("active");
   hideSubMenu();
 }
 function showSubMenu(hasChildren){
    subMenu = hasChildren.querySelector(".sub-menu");
    subMenu.classList.add("active");
    subMenu.style.animation = "slideLeft 0.5s ease forwards";
    const menuTitle = hasChildren.querySelector("i").parentNode.childNodes[0].textContent;
    menu.querySelector(".current-menu-title").innerHTML=menuTitle;
    menu.querySelector(".mobile-menu-head").classList.add("active");
   menu.classList.add("submenu_active");
 }

 function  hideSubMenu(){  
    if (subMenu) {
      const closingSubMenu = subMenu;
      closingSubMenu.style.animation = "slideRight 0.5s ease forwards";
      setTimeout(() => {
        closingSubMenu.classList.remove("active");
      }, 300);
    }
    menu.querySelector(".current-menu-title").innerHTML="";
    menu.querySelector(".mobile-menu-head").classList.remove("active");
   menu.classList.remove("submenu_active");
 }
 
 window.onresize = function(){
 	if(this.innerWidth >991){
 		if(menu.classList.contains("active")){
 			toggleMenu();
 		}

 	}
 }

